import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=06afc975&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=06afc975&prod&lang=less&scoped=true"
import style1 from "./Login.vue?vue&type=style&index=1&id=06afc975&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06afc975",
  null
  
)

export default component.exports